<template>
    <img :src="imgUrl"
        :width="width"
        :height="height">
</template>
<script>
import { getFilePreviewUrl } from '_u/helper'
import { getToken, getTarget } from '_u/helper'

export default {
    props: {
        src: {
            type: [String, Blob],
            require: true
        },
        type: {
            type: String,
            default: "url",
            validator: (val) => ["id", "url", "blob"].some(v => v == val)
        },
        action: {
            type: String,
            default: function(){
                return getFilePreviewUrl()
            }
        },
        height: {
            type: String,
            default: ""
        },
        width: {
            type: String,
            default: ""
        }
    },

    computed: {
        imgUrl() {
            if (this.type == "id") {
                var url = this.action + "?"

                url += "id=" + this.src

                if (process.env.VUE_APP_IDENTITY_AUTH == "token") {
                    url += "&Authorization=" + getToken()
                    url += "&target=" + getTarget()
                }

                return url
            }

            if (this.type == "url") {
                return this.src
            }

            if (this.type == "blob" && this.src) {
                return URL.createObjectURL(this.src)
            }
        }
    }
}
</script>
